// Constants copied from SDK: https://github.com/botpress/botpress/blob/master/packages/sdk/src/consts.ts
export const BOT_ID_HEADER = 'x-bot-id'
export const BOT_USER_ID_HEADER = 'x-bot-user-id'
export const WEBHOOK_ID_HEADER = 'x-webhook-id'
export const CONFIGURATION_TYPE_HEADER = 'x-bp-configuration-type'
export const CONFIGURATION_PAYLOAD_HEADER = 'x-bp-configuration'
export const OPERATION_TYPE_HEADER = 'x-bp-operation'
export const OPERATION_SUBTYPE_HEADER = 'x-bp-type'
export const LOG_DELIMITER = '<|MESSAGE_END|>\n'
